export default __webpack_public_path__ + "0601c041d134a2d66e8fbda33d51be75.png";